import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface PageHeaderProps {
  title: string;
  icon?: ReactNode;
  className?: string;
  sticky?: boolean;
  /** Optional trailing element (e.g. action button) */
  trailing?: ReactNode;
}

export function PageHeader({
  title,
  icon,
  className,
  sticky = true,
  trailing,
}: PageHeaderProps) {
  return (
    <div className={cn(
      "bg-white border-b border-gray-200",
      sticky && "sticky top-0 z-10",
      className
    )}>
      <div className="container mx-auto px-4 py-3 max-w-4xl">
        <div className="flex items-center justify-between gap-4">
          {/* Title Section */}
          <h1 className="text-xl font-bold text-gray-900 flex items-center gap-2">
            {icon}
            {title}
          </h1>

          {trailing && <div className="flex items-center gap-2">{trailing}</div>}
        </div>
      </div>
    </div>
  );
}
